import createReducer from 'utils/redux/createReducer'

const initialState = {
	property: 'All'
	, type: 'Real Estate Agents'
}

export default createReducer(initialState, {
	AGENTS_FILTER_UPDATED: (currentState, action) => (
		{
			property: (action.data.property)? action.data.property : currentState.property
		  , type: (action.data.type)? action.data.type : currentState.type
		}
	)
  , CLEAR_AGENTS_FILTERS: () => initialState
})



// WEBPACK FOOTER //
// ./src/reducers/agentsFilters.js